export const contractAddress = "0x6858b79E70Db50b1722f59D531A8437461C96332";
export const tokenAddress = "0xE7916aCC470b5C4EF4Ba7944e79f9651CACf22B1";

//0x6858b79e70db50b1722f59d531a8437461c96332
//0x6858b79E70Db50b1722f59D531A8437461C96332
